import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import * as Scroll from 'react-scroll';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import {
    ReadPropsIncomingMessage, 
    RegisterConfirmationAnswer,
    ReadPropsSummary,
    ReadAsMaster,
} from '../../../../home/helper/request.props.js';

import {
    PresenterReadIncomingMessage, 
    PresenterConfirmationAnswer,
    PresenterReadAsMaster,
    PresenterReadSummary,
} from '../../../../home/presenter.js'

import IncomingMessageRow from './IncomingMessageRow.js';
import toUTCtime from '../../../../helper/UTCtime';
import FormHelper from '../../form.js';

// Modal
import ModalDueDate from "../Modal/ModalDueDate.js"
import ModalReject from '../Modal/ModalReject.js'
import ModalDialogue from '../Modal/ModalDialogue.js'
import ModalDetailMyAsset from '../Modal/ModalDetailMyAsset.js'

import { StoreUserInfoFromMobile } from "user/action";

// TOAST
import { toast } from 'react-toastify';
import windowStop from '../../../../utils/windowStop.js';

let Events     = Scroll.Events;
let scroll     = Scroll.animateScroll;
let scrollSpy  = Scroll.scrollSpy;

const { ReactNativeWebView } = window;

class IncomingMessageList extends React.Component {
  constructor(props) {
    super(props);

    this.nextParams = {
      type: 'all',
      status: 'all',
      search: '',
    };

    this.state = {
      loadingLoadMore  : false,    
      isLoading        : false,
      isLoadmore       : false,
      // RowElement       : '',
      RawData          : [],
      Pagination : {
        total        : 0,
        curent       : 0,
      },
      Counter          : null,
      modalDueDate     : false,
      modalReject      : false,
      modalDialogue    : false,
      modalDetail      : false,
      nextRsv          : false,
      ActiveDataModal  : null,
      DueDateToUTCtime : null,
      NextPage         : null,
      next             : null,
      SITE             : null,
      LOCATION         : null,
      assetData        : null,
      params :{
          type             : 'in',
          status           : 'unconfirmed'
      },
      in_unconfirmed : 0,
      out_unconfirmed: 0,
      flash         : {
        flashing : null,
        in_flash : null,
        out_flash: null,
      },

      // This SelectedItem is use for list bull
      SelectedItem : [],
    }

    this.generateRow          = this.generateRow.bind(this);
    this.insertNewRow         = this.insertNewRow.bind(this);
    this.updateRow            = this.updateRow.bind(this);
    
    this.toogleModalDueDate   = this.toogleModalDueDate.bind(this);
    this.toogleModalReject    = this.toogleModalReject.bind(this);
    this.toggleModalDialogue  = this.toggleModalDialogue.bind(this)
    this.confirmationAnswer   = this.confirmationAnswer.bind(this);

    this.onReadSuccess        = this.onReadSuccess.bind(this);
    this.OnRegisterConfirmationAnswerSuccsess = this.OnRegisterConfirmationAnswerSuccsess.bind(this);
    this.OnRegisterConfirmationAnswerFailed = this.OnRegisterConfirmationAnswerFailed.bind(this);
    
    this.onReadSummarySuccess = this.onReadSummarySuccess.bind(this);
    this.onReadSummaryFailed  = this.onReadSummaryFailed.bind(this);
    this.loadData             = this.loadData.bind(this);
  
    this.openModalDetail      = this.openModalDetail.bind(this);
    this.closeModalDetail     = this.closeModalDetail.bind(this);

    this.handleSearch         = this.handleSearch.bind(this);
    this.enterSearch          = this.enterSearch.bind(this);

    this.handleMobile = this.handleMobile.bind(this);
    this.onChangeBulk = this.onChangeBulk.bind(this)
    this.handleBulkAll = this.handleBulkAll.bind(this)
  }

  updateRow(data) {
    const items = this.state.RawData;
    for (let i = 0; i < items.length; i++){
      if (items[i].Alias === data.Alias){
        if (this.state.params.status === 'unconfirmed'){
          items.splice(i, 1)
        }else{
          items[i] = data
        }
        break;
      }
    }

    let newState = {
      RawData: items,
    };
    this.setState(newState);
  }
  
  toggleModalDialogue(data,action=false){
    this.setState({
      nextRsv : action,
      ActiveDataModal: data,
      modalDialogue:!this.state.modalDialogue
    })
  }

  toogleModalDueDate(data,myBooking=false) {
    this.setState({
      ActiveDataModal: data,
      modalDueDate   : !this.state.modalDueDate,
    })
  }

  toogleModalReject(data){
    this.setState({
      ActiveDataModal: data,
      modalReject : !this.state.modalReject
    })
  }

  openModalDetail(asset){
    this.setState({
        modalDetail : true,
        assetData: asset
    })
    // PresenterReadBookedAsset(
    //   ReadPropsBookedAsset(
    //     'getDetails', this, 
    //     this.onReadSuccess, 
    //     this.onReadFailed,
    //     'field=&search=',
    //     'ordering=-SortDate,-CreatedTime',
    //     1,
    //     alias
    //   )
    // )
  }

  closeModalDetail(){
    this.setState({
      modalDetail : false
    })
  }

  confirmationAnswer(action, data) {
    const {SelectedItem} = this.state

    if(action === 'accept') {
      data.startDate._d.setHours(8);
      data.startDate._d.setMinutes(59);
      data.startDate._d.setSeconds(59);

      this.RequestParams = {          
        // ActiveDataModal     : data.ActiveDataModal,
        DueDateToUTCtime    : toUTCtime(data.startDate._d),
        Answer              : 'yes',       
        MyReservation       : null,
        StartDate           : null,
        Site                : data.Site ? data.Site.value : '',
        Location            : data.Location ? data.Location.value : '',        
      }

      if(this.state.nextRsv){
        data.chStartDate._d.setHours(9);
        data.chStartDate._d.setMinutes(0);
        data.chStartDate._d.setSeconds(0);

        this.RequestParams.StartDate = toUTCtime(data.chStartDate._d)
        this.RequestParams.MyReservation = data.nextReservation
      }

      if(!FormHelper.ValidateFormAcceptReassign(this.RequestParams)) {
        return
      }

      if(SelectedItem.length > 0) {
        for(let i=0; i < SelectedItem.length; i++) {
          this.RequestParams.ActiveDataModal = SelectedItem[i]
          PresenterConfirmationAnswer(
            RegisterConfirmationAnswer("accept", this, this.OnRegisterConfirmationAnswerSuccsess, this.OnRegisterConfirmationAnswerFailed)
          )
        }
      } else {
        this.RequestParams.ActiveDataModal = data.ActiveDataModal
        PresenterConfirmationAnswer(
          RegisterConfirmationAnswer("accept", this, this.OnRegisterConfirmationAnswerSuccsess, this.OnRegisterConfirmationAnswerFailed)
        )
      }

    } else {

      this.RequestParams = {
        DueDateToUTCtime: null,
        Answer: 'no',
      }

      if(SelectedItem.length > 0) {
        for(let i=0; i < SelectedItem.length; i++) {
          this.RequestParams.ActiveDataModal = SelectedItem[i]
          PresenterConfirmationAnswer(
            RegisterConfirmationAnswer("reject", this, this.OnRegisterConfirmationAnswerSuccsess, this.OnRegisterConfirmationAnswerFailed)
          )
        }
      } else {
        this.RequestParams.ActiveDataModal = data.ActiveDataModal
        PresenterConfirmationAnswer(
          RegisterConfirmationAnswer("reject", this, this.OnRegisterConfirmationAnswerSuccsess, this.OnRegisterConfirmationAnswerFailed)
        )
      }
    }

  }

  OnRegisterConfirmationAnswerSuccsess(params, response) {
    if( params.action === 'accept' ) {
      params.self.setState({
        modalDueDate: false,
        SelectedItem: []
      })
      toast.success("Accept reasign success");    
    } else {
      params.self.setState({
        modalReject: false,
        SelectedItem: []
      }) 
      toast.success("Reject reasign success");    
    }
    params.self.updateRow(response.data);
  }

  OnRegisterConfirmationAnswerFailed(params, response) {
    if( params.action === 'accept' ) {
      console.log("response Failed :" + params.action);
    } else {
      console.log("response Failed :" + params.action);
    }
    
    try {
      if(response.hasOwnProperty('data')) {
        if(response.data.hasOwnProperty('detail')) {
          toast.error(response.data.detail)
        }
      }
    }catch(error) {
      console.log(error)
    }
  }

  handleBulkAll(e) {
    let newItem = [...this.state.SelectedItem]
    let data = this.state.RawData

    for(let i = 0; i < data.length; i++ ) {
      let can_assign = data[i].ToUser === this.props.UserReducer.username
      if(can_assign && data[i].Response === null) {
        if(e.target.checked){ // this checked for undefined
          newItem = [...newItem, data[i]]
        } else if(e.target.checked === false) {
          newItem = []
        }
      }
    }

    this.setState({
      SelectedItem: newItem
    })
  }

  removeBulkFromModal = (alias) => {
    let newItem = [...this.state.SelectedItem]
    newItem = newItem.filter(item => item.Alias !== alias)

    this.setState({
      SelectedItem: newItem
    })

  }

  onChangeBulk(data, alias, checked=false) {
    let newItem = [...this.state.SelectedItem]
    
    if(checked) {
      //************* checked and add data to list */ 
      newItem = [...newItem, data]
    }else {
      //************* unchecked and remove data from list */
      newItem = newItem.filter(item => item.Alias !== alias)
    }
    this.setState({
      SelectedItem: newItem
    })
  }

  generateRow(row) {
    var count = {all: 0, unconfirmed: 0, confirmed: 0};
    let selected_list = []

    var element = row.map((val, index) => {
      if (val.Response === null){
        count.unconfirmed += 1;     
      }else{
        count.confirmed += 1;
      }
      count.all += 1;
      
      if(this.state.SelectedItem.length > 0) {
        selected_list = this.state.SelectedItem
      }
      
      return (
        <IncomingMessageRow 
          self={this} 
          openModalDetail={this.openModalDetail}
          RowData={val} 
          key={val.Alias} 
          UserReducer={this.props.UserReducer}
          onChangeBulk={this.onChangeBulk}
          selected={selected_list}
        />
      )
    })
    return {el: element, counter: count};
  }

  insertNewRow(data){
    const items = this.state.RawData
    items.unshift(data)
    this.setState({ RawData : items })
  }

  loadData() {
    this.setState(
      { isLoading: true, loadingLoadMore: true },
      () => PresenterReadIncomingMessage(
        ReadPropsIncomingMessage("Read", this, this.onReadSuccess, this.onReadFailed )
      )
    );
  }
  /**
  |--------------------------------------------------
  | params.action have 3 option = {'Read', 'getDetails', 'Next'}
  |--------------------------------------------------
  */
  onReadSuccess(params, response) {
    let lastMessage = ''

    if (response.data.results && response.data.results.length > 1){
      let createdTime = response.data.results[response.data.results.length - 1].Accessed.CreatedTime
      lastMessage = toUTCtime(moment(createdTime)._d) + "." + createdTime.split(".")[1].split("+")[0]
    }

    if(params.action === 'Read') {
      this.setState({
        loadingLoadMore : false,
        isLoading       : false,
        RawData         : response.data.results,
        Pagination      : {
          total       : response.data.count,
          curent      : response.data.results.length
        },  
        NextPage        : lastMessage,
        next            : response.data.next,
        Counter         : this.generateRow(response.data.results).counter,
        params          : Object.assign({}, this.nextParams)
      })
    } else if(params.action === 'getDetails') {
      this.setState({
        assetData : response.data.results[0]
      })
    } else {
      this.setState({              
        loadingLoadMore : false,
        isLoading       : false,
        isLoadmore      : true,
        Pagination      : {
          total         : this.state.Pagination.total,
          curent        : this.state.Pagination.curent + response.data.results.length
        }, 
        NextPage        : lastMessage,
        next            : response.data.next,
        Counter         : this.generateRow(this.state.RawData).counter,
        RawData         : [...this.state.RawData, ...response.data.results],
        params          : Object.assign({}, this.nextParams)
      })
    }
  }

  readSummary() {
    PresenterReadSummary(
      ReadPropsSummary("Read", this, this.onReadSummarySuccess, this.onReadSummaryFailed)
    )
  }

  onReadSummarySuccess(params, response) {
    this.props.setInUnconfirmed(response.data.in_unconfirmed)
    this.props.setOutUnconfirmed(response.data.out_unconfirmed)
    this.props.setFlashing(
      response.data.flashing,
      response.data.in_flash,
      response.data.out_flash
    )
    this.props.setUnconfirmedConfirmation(
      response.data.in_unconfirmed, 
      response.data.out_unconfirmed, 
      response.data.flashing, 
      response.data.in_flash, 
      response.data.out_flash
    )
  }

  onReadSummaryFailed(error) {
    console.log(error)
  }

  loadAsMaster() {
    PresenterReadAsMaster(
      ReadAsMaster("SITE", this, this.ReadMasterSuccess, this.onReadFailed)
    )

    PresenterReadAsMaster(
      ReadAsMaster("LOCATION", this, this.ReadMasterSuccess, this.onReadFailed)
    )
  }

  ReadMasterSuccess(params, response) {
    switch(params.action) {
      case "SITE":
        params.self.setState({ SITE: response.data })
        break;
      case "LOCATION":
        params.self.setState({ LOCATION: response.data })
        break;
      default:
        break;
    }
  }  

  onReadFailed(params, response) {
    console.log('Read failed')
  }

/*  ============ Toolbar ============ */
  getData(value, key) { 
    if (this.state.params[key] !== value){
      this.nextParams[key] = value;
      this.loadData();
    }
  }

  // LOADMORE
  LoadMore() {        
    this.setState({
      loadingLoadMore: true,
    })
    PresenterReadIncomingMessage( 
      ReadPropsIncomingMessage("Next", this, this.onReadSuccess, this.onReadFailed) 
    )
  }

  handleSearch(e) {
    this.nextParams.search = e.target.value
  }

  enterSearch(e) {
    if(e.key === "Enter") {
      this.loadData()
    }
  }

  RenderLoadMoreButton() {
    if(this.state.loadingLoadMore) {
      return(
        <div><button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button></div>
      )
    } else {
      if(this.state.next !== null) {
        return (
          <div><button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button></div>
        )
      }
    }
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  handleMobile({ data }){
    this.props.RunRedux(
      StoreUserInfoFromMobile(JSON.parse(data))
    );
  }

  /*  ============ LifeCyle ============ */
  componentDidMount() {
    if(!ReactNativeWebView){
      this.loadData();
      this.readSummary();
    }else{
      // create link to mobile app
      window.addEventListener("message", this.handleMobile);
      document.addEventListener("message", this.handleMobile);
      ReactNativeWebView.postMessage("mounted");
    }

    Events.scrollEvent.register('begin');
    Events.scrollEvent.register('end');
    scrollSpy.update();
    this.props.onRef && this.props.onRef(this);
  }

  componentWillUnmount() {
    windowStop()
    
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
    this.props.onRef && this.props.onRef(undefined);
    if(ReactNativeWebView){
      window.removeEventListener("message", this.handleMobile);
      document.removeEventListener("message", this.handleMobile);
    }
  }

  componentWillReceiveProps(nextProps){
    if(ReactNativeWebView){
      if(!isEmpty(nextProps.UserReducer.username)){
        this.loadData();
      }
    }
  }

  RenderRow() {
    if(this.state.isLoading) {
      return (
        <div className="incoming-loading">
          <h5>Load Reasign Message . . .</h5>
        </div>
      )
    } else if (this.state.RawData.length > 0) {
      return (this.generateRow(this.state.RawData).el)
    } else if (this.state.RawData.length === 0) {
      return (
        <div className="incoming-not-found">
          <h5><span className="icon-envelope-letter"></span>&nbsp;Reasign Message empty</h5>
        </div>
      )
    } else {
      return (
        <div className="incoming-not-found">
          <h5>&nbsp;Something went wrong !</h5>
        </div>
      )
    }
  }

  RenderPagination() {
    const {total, curent} = this.state.Pagination

    if ( total === 0 ) {
      return (null)
    } else {
      return (
        <div className="btn-group float-right">
          <label className="total-email">1 - { curent < total ? curent : total} from {total}</label>
        </div>
      )
    }
  }

  renderBulkButton() {
    //************* SelectedItem is list bulk */
    const {SelectedItem} = this.state
    if(SelectedItem && SelectedItem.length > 0) {
      return(
        <span>
          <button 
            onClick={(e)=>{e.stopPropagation(); this.toogleModalReject(SelectedItem[0])}} 
            type="button" 
            disabled={this.state.isLoading}
            className="btn btn-danger">Bulk Reject</button>
          &nbsp;
          <button 
            onClick={(e)=>{e.stopPropagation(); this.toogleModalDueDate(SelectedItem[0])}}
            type="button" 
            disabled={this.state.isLoading}
            style={{'marginRight': '1rem'}}
            className="btn btn-success">Bulk Accept</button>
        </span>
      )
    } else {
      return null
    }
    
  }

  render() {
    return (
      <div className={classnames("email-app-new", {'p-3': ReactNativeWebView})}>
        <main>
          <div className="toolbar">
            <div className="row">
              <div className="col-md-12 t-filter">
                <div className="btn-group second-toolbar">
                  <div className="hidden-sm-down">
                    <button type="button" className="btn btn-light grey-checkbox">
                      <label className="container-checkbox" onClick={this.handleBulkAll}>
                        <input type="checkbox" checked={this.state.SelectedItem.length > 0} disabled={this.state.isLoading}/>
                        <span className="checkmark"></span>
                      </label>
                    </button>
                    <button onClick={this.loadData} style={{'marginRight':'1rem'}} type="button" title="Refresh" className="btn btn-light" disabled={this.state.isLoading} >
                      <i className="icon-refresh"></i>
                    </button>
                  {this.renderBulkButton()}
                  </div>
                  <div style={{'marginRight':'10px'}}>
                    <button disabled={this.state.isLoading} type="button" onClick={()=> {this.getData("all", 'status');this.getData("all", 'type')}} title="All" className={this.nextParams.status === 'all' && this.nextParams.type === 'all' ? 'btn btn-light btn button-toolbar-active' : 'btn btn-light'}>All</button>
                    <button disabled={this.state.isLoading} type="button" onClick={()=> this.getData("in", 'type')} className={this.nextParams.type === 'in' ? 'btn btn-light button-toolbar-active hidden-xs-down' : 'hidden-xs-down btn btn-light'}>In</button>
                    <button disabled={this.state.isLoading} type="button" onClick={()=> this.getData("out", 'type')} className={this.nextParams.type === 'out' ? 'btn btn-light button-toolbar-active hidden-xs-down' : 'hidden-xs-down btn btn-light'}>Out</button>
                  </div> 
                  <button disabled={this.state.isLoading} type="button" onClick={()=> this.getData("unconfirmed", 'status')} className={this.nextParams.status === 'unconfirmed' ? 'btn btn-light button-toolbar-active' : 'btn btn-light'} title="Unconfirmed">Unconfirmed</button>
                  <button disabled={this.state.isLoading} type="button" onClick={()=> this.getData("confirmed", 'status')} className={this.nextParams.status === 'confirmed' ? 'btn btn-light button-toolbar-active' : 'btn btn-light'} title="Confirmed">Confirmed</button>
                </div>
              </div>
              <div className="col-md-9">
                <div className="icon-overlay">
                  <span className="icon-magnifier"></span>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Search asset, to user, answer or response message"
                    onChange={this.handleSearch}
                    onKeyDown={this.enterSearch}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="col-md-3">
                {this.RenderPagination()}
              </div>
            </div>
            {/* SECONDS TOOLBAR FOR MOBILE */}
            <div className="second-toolbar st-mobile hidden-md-up">
              <button type="button" className="btn btn-light grey-checkbox">
                <label className="container-checkbox" onClick={this.handleBulkAll}>
                  <input type="checkbox" checked={this.state.SelectedItem.length > 0} disabled={this.state.isLoading}/>
                  <span className="checkmark"></span>
                </label>
              </button>
              {this.state.SelectedItem.length <= 0 &&
                <button onClick={this.loadData} type="button" title="Refresh" className="btn btn-light" disabled={this.state.isLoading} >
                  <i className="icon-refresh"></i>
                </button>
              }
              {this.renderBulkButton()}
            </div>
          </div>
          <div className="messages">
            {this.RenderRow()}
          </div>
        </main>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            {this.RenderLoadMoreButton()}
            <button className="back-to-top" onClick={()=>this.scrollToTop()}><i className="icon-arrow-up"></i></button>
          </div>
        </div>
        <ModalDueDate
          selectedItem       = {this.state.SelectedItem} // list of bulk
          removeBulkFromModal = {this.removeBulkFromModal}
          activeDataModal    = {this.state.ActiveDataModal}
          masterSite         = {this.state.SITE}
          masterLocation     = {this.state.LOCATION}
          nextReservation    = {this.state.nextRsv}
          onClose            = {() => this.setState({ nextRsv : false })}
          isOpen             = {this.state.modalDueDate}
          toogleModalDueDate = {this.toogleModalDueDate}
          confirmationAnswer = {this.confirmationAnswer}
          UserReducer        = {this.props.UserReducer}
        />
        <ModalReject 
          selectedItem        = {this.state.SelectedItem} // list of bulk
          removeBulkFromModal = {this.removeBulkFromModal}
          activeDataModal     = {this.state.ActiveDataModal}
          toogleModalReject   = {this.toogleModalReject}
          isOpen              = {this.state.modalReject}
          confirmationAnswer  = {this.confirmationAnswer}
        />
        
        <ModalDetailMyAsset 
          ModalState         = {this.state.modalDetail}
          CloseModal         = {this.closeModalDetail}
          SelectedItems     = {this.state.assetData}
          UserReducer     = {this.props.UserReducer}
        />

        <ModalDialogue 
          activeDataModal = {this.state.ActiveDataModal}
          isOpen = {this.state.modalDialogue}
          toggleModalDialogue = {this.toggleModalDialogue}
          toogleModalDueDate = {this.toogleModalDueDate}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    UserReducer     : state.UserReducer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    RunRedux: (data) => {
      dispatch(data);
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IncomingMessageList);


// WEBPACK FOOTER //
// ./src/App/home/helper/component/IncomingMessage/IncomingMessageList.js